"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _MarginTransferAssetsFormComponent = _interopRequireDefault(require("./MarginTransferAssetsFormComponent"));
var _selectors = require("../../redux/margin/selectors");
var _transferActions = require("../../redux/actions/transferActions");
var _actions = require("../../redux/margin/actions");
var _positionActions = require("../../redux/actions/positionActions");
var _spotAccountInfo = require("../../redux/actions/spotAccountInfo");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _formObj$values$Produ3;
  var form = state.form,
    _state$user = state.user,
    accounts = _state$user.accounts,
    selectedAccountId = _state$user.selectedAccountId,
    _state$apexCore = state.apexCore,
    products = _state$apexCore.product.products,
    positions = _state$apexCore.position.positions,
    _state$margin = state.margin,
    UsableMarginNotional = _state$margin.accountInfo.UsableMarginValue,
    marginProducts = _state$margin.products.data;
  var formObj = form.marginTransferAssets || {
    values: {}
  };
  var marginAccount = (0, _selectors.marginAccountSelector)(state);
  var mainAccount = (0, _selectors.mainAccountSelector)(state);
  var initialSenderAccount = selectedAccountId ? accounts.find(function (account) {
    return account.AccountId === selectedAccountId;
  }) : mainAccount;
  var initialReceiverAccount = initialSenderAccount.AccountType === mainAccount.AccountType ? marginAccount : mainAccount;
  var selectedReceiverAccount = accounts.find(function (account) {
    var _formObj$values$Recei;
    return account.AccountId === ((_formObj$values$Recei = formObj.values.ReceiverAccount) === null || _formObj$values$Recei === void 0 ? void 0 : _formObj$values$Recei.value);
  });
  var isMarginReceiver = (selectedReceiverAccount === null || selectedReceiverAccount === void 0 ? void 0 : selectedReceiverAccount.AccountType) === 'Margin';
  var selectedSenderAccount = accounts.find(function (account) {
    var _formObj$values$Sende;
    return account.AccountId === ((_formObj$values$Sende = formObj.values.SenderAccount) === null || _formObj$values$Sende === void 0 ? void 0 : _formObj$values$Sende.value);
  });
  var accountPositions = positions[selectedSenderAccount ? selectedSenderAccount.AccountId : initialSenderAccount.AccountId];
  var accountAssets = products.map(function (p) {
    var _accountPositions$p$P;
    var position = (_accountPositions$p$P = accountPositions[p.ProductId]) !== null && _accountPositions$p$P !== void 0 ? _accountPositions$p$P : {};
    var matchingProduct = marginProducts.find(function (product) {
      return product.ProductId === p.ProductId;
    });
    var isEnabled = !(isMarginReceiver && !(matchingProduct !== null && matchingProduct !== void 0 && matchingProduct.CollateralEnabled));
    return {
      value: p.ProductId,
      label: "".concat(p.Product, " ").concat(p.ProductFullName),
      amount: Object.keys(position).length > 0 ? position.Amount - position.Hold : 0,
      ProductSymbol: p.Product,
      ProductId: p.ProductId,
      DecimalPlaces: p.DecimalPlaces,
      isEnabled: isEnabled
    };
  });
  var maxAmount;
  var isMarginSender = (selectedSenderAccount === null || selectedSenderAccount === void 0 ? void 0 : selectedSenderAccount.AccountType) === 'Margin';
  var selectedAsset = accountAssets.find(function (a) {
    var _formObj$values$Produ;
    return a.ProductId === Number((_formObj$values$Produ = formObj.values.Product) === null || _formObj$values$Produ === void 0 ? void 0 : _formObj$values$Produ.value);
  });
  if (isMarginSender) {
    var _formObj$values$Produ2;
    maxAmount = (0, _selectors.marginTransferAmountSelector)(state, (_formObj$values$Produ2 = formObj.values.Product) === null || _formObj$values$Produ2 === void 0 ? void 0 : _formObj$values$Produ2.value);
  } else {
    var productBalance = selectedAsset === null || selectedAsset === void 0 ? void 0 : selectedAsset.amount;
    maxAmount = Math.max(productBalance || 0, 0);
  }

  // Below filters out small balances based on decimal places for a given product
  // For example, for USD (2 decimal places), it checks if balance is greater than or equal to 0.01
  var assetsWithBalances = accountAssets.filter(function (asset) {
    return asset.amount >= Math.pow(10, -asset.DecimalPlaces);
  });
  return {
    formObj: formObj,
    assets: accountAssets,
    initialValues: {
      SenderAccount: {
        value: initialSenderAccount === null || initialSenderAccount === void 0 ? void 0 : initialSenderAccount.AccountId,
        label: initialSenderAccount === null || initialSenderAccount === void 0 ? void 0 : initialSenderAccount.AccountName
      },
      ReceiverAccount: {
        value: initialReceiverAccount === null || initialReceiverAccount === void 0 ? void 0 : initialReceiverAccount.AccountId,
        label: initialReceiverAccount === null || initialReceiverAccount === void 0 ? void 0 : initialReceiverAccount.AccountName
      },
      Product: ownProps.defaultProductId ? accountAssets.find(function (p) {
        return p.ProductId === ownProps.defaultProductId;
      }) : accountAssets[0]
    },
    accounts: accounts,
    maxAmount: maxAmount,
    DecimalPlaces: (_formObj$values$Produ3 = formObj.values.Product) === null || _formObj$values$Produ3 === void 0 ? void 0 : _formObj$values$Produ3.DecimalPlaces,
    assetsWithBalances: assetsWithBalances,
    UsableMarginNotional: UsableMarginNotional,
    marginAccountId: marginAccount === null || marginAccount === void 0 ? void 0 : marginAccount.AccountId,
    isMarginSender: isMarginSender,
    isMarginReceiver: isMarginReceiver,
    isMarginSelected: (0, _selectors.isMarginActiveSelector)(state)
  };
};
var Form = (0, _reduxForm.reduxForm)({
  form: 'marginTransferAssets',
  onSubmit: function onSubmit(payload, dispatch, _ref) {
    var _payload$ReceiverAcco, _payload$SenderAccoun, _payload$ReceiverAcco2, _payload$SenderAccoun2;
    var closeModal = _ref.closeModal,
      isMarginSelected = _ref.isMarginSelected,
      marginAccountId = _ref.marginAccountId;
    var spotAccountId = ((_payload$ReceiverAcco = payload.ReceiverAccount) === null || _payload$ReceiverAcco === void 0 ? void 0 : _payload$ReceiverAcco.value) === marginAccountId ? (_payload$SenderAccoun = payload.SenderAccount) === null || _payload$SenderAccoun === void 0 ? void 0 : _payload$SenderAccoun.value : (_payload$ReceiverAcco2 = payload.ReceiverAccount) === null || _payload$ReceiverAcco2 === void 0 ? void 0 : _payload$ReceiverAcco2.value;
    dispatch((0, _transferActions.transferFunds)({
      SenderAccountId: (_payload$SenderAccoun2 = payload.SenderAccount) === null || _payload$SenderAccoun2 === void 0 ? void 0 : _payload$SenderAccoun2.value,
      ReceiverAccountId: payload.ReceiverAccount.value,
      ProductId: payload.Product.value,
      ProductSymbol: payload.Product.ProductSymbol,
      Amount: payload.Amount,
      Notes: 'margin transfer'
    }));
    if (!isMarginSelected) {
      dispatch((0, _positionActions.getAccountPositions)(spotAccountId));
      dispatch((0, _spotAccountInfo.getAccountSummary)(spotAccountId));
    }
    closeModal();
  }
})(_MarginTransferAssetsFormComponent["default"]);
var MarginTransferAssetsFormContainer = (0, _reactRedux.connect)(mapStateToProps, {
  change: _reduxForm.change,
  untouch: _reduxForm.untouch,
  getMaxTransferAmount: _actions.getMaxTransferAmount
})(Form);
MarginTransferAssetsFormContainer.propTypes = {
  initialSenderId: _propTypes["default"].number,
  defaultProductId: _propTypes["default"].number
};
var _default = exports["default"] = MarginTransferAssetsFormContainer;